export const codeErrors = {
  4220015: {
    message: "Bekleyen aktivasyon işlemi mevcuttur. Telefonunuza gelen kodu giriniz.",
    buttonText: "Doğrula",
    errorId: "pending-activation",
  },
  4220014: {
    message: "Servise erişilemiyor; lütfen daha sonra tekrar deneyiniz.",
    buttonText: "Tekrar Dene",
    errorId: "no-service",
  },
  4220016: {
    message: "Eski bir kod girdiniz, lütfen en son gelen kodu girerek tekrar deneyiniz.",
    buttonText: "Tekrar Dene",
    errorId: "expired-time",
  },
  4220019: {
    message:
      "Yanlış kod girişi yaptınız. Lütfen en son gelen kodu girerek veya süre sona erdiğinde yeni bir kod alarak tekrar deneyiniz.",
    buttonText: "Tekrar Dene",
    errorId: "wrong-code",
  },
  4000004: {
    message: "Bu cep telefonu başka bir kullanıcıda tanımlıdır.",
    buttonText: "Tekrar Dene",
    errorId: "defined-another-user",
  },
  4000007: {
    message: "Bilgilerinizi eksik ya da hatalı girdiniz. Lütfen kontrol edip tekrar deneyiniz.",
    buttonText: "Tekrar Dene",
    errorId: "defined-another-user",
  },
  4030002: {
    message: "Hesabınızın borcu olmasından dolayı bu hizmetimizi kullanamamaktasınız.",
    buttonText: "",
    errorId: "debt-account",
  },
};

export const equalsContractNameToId = {
  explicitConsent: 5,
  individualKvkk: 4,
  membership: 2,
};
